import { render, staticRenderFns } from "./menuShopCart.vue?vue&type=template&id=734ac4ac&scoped=true&"
import script from "./menuShopCart.vue?vue&type=script&lang=ts&"
export * from "./menuShopCart.vue?vue&type=script&lang=ts&"
import style0 from "./menuShopCart.vue?vue&type=style&index=0&id=734ac4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734ac4ac",
  null
  
)

export default component.exports